<div (click)="copy()" style="cursor: pointer; display: flex; flex-direction: column">
  Er ging iets mis
  <span style="font-size: 0.85em"
    >Foutcode: <b>{{ toastRef.data.shortId }}</b></span
  >
  <small style="opacity: 0.7; margin-top: 4px">Klik om volledige ID te kopiëren</small>
</div>
